// src/components/CustomFields/ProgramField.js
import React, { useEffect, useState } from "react";
import SelectField from "./SelectField";


export default function ProgramsFieldRsSm(props) {
  const fixedPrograms = [
    { id: 1, name: "Receta solidaria" },
    { id: 2, name: "Solo mujer" },
  ];

  return (
    <SelectField
      divClassName={props.divClassName}
      fieldClassName={props.fieldClassName}
      displayText={props.displayText}
      id="programs"
      label="Seleccione"
      name="program"
      value={props.value}
      onChange={props.onChange}
      allValues={fixedPrograms}
      disabled={props.disabled || false}
    />
  );
}
